import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const BRAND_GRADIENT = 'linear-gradient(135deg, #EC1E9C 0%, #9C3BC4 52%, #5B3FE0 100%)'
const WORD_GRADIENT = 'linear-gradient(90deg, #EC1E9C 0%, #9C3BC4 55%, #5B3FE0 100%)'

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [step, setStep] = useState('login')
  const [code, setCode] = useState('')
  const [challenge, setChallenge] = useState('')
  const [maskedEmail, setMaskedEmail] = useState('')
  const [resent, setResent] = useState(false)
  const navigate = useNavigate()
  const { saveAccount, setSelectedBrand } = useBrand()

  async function finishLogin(data) {
    localStorage.setItem('adminToken', data.token)
    saveAccount(data.account)
    if (data.account.role === 'brand_admin' && data.account.brand_id) {
      const brandRes = await axios.get(`${API}/admin/brands/${data.account.brand_id}`, {
        headers: { Authorization: data.token }
      })
      setSelectedBrand(brandRes.data)
    }
    navigate('/')
  }

  async function handleLogin(e) {
    if (e) e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password })
      if (res.data.requires2fa) {
        setChallenge(res.data.challenge)
        setMaskedEmail(res.data.email || email)
        setCode('')
        if (step === 'code') {
          setResent(true)
          setTimeout(() => setResent(false), 3000)
        }
        setStep('code')
        setLoading(false)
        return
      }
      await finishLogin(res.data)
    } catch (err) {
      setError(err.response?.data?.error || 'Hatalı e-posta veya şifre')
      setLoading(false)
    }
  }

  async function handleVerify(e) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const res = await axios.post(`${API}/admin/login/verify`, { challenge, code })
      await finishLogin(res.data)
    } catch (err) {
      setError(err.response?.data?.error || 'Hatalı kod')
      setLoading(false)
    }
  }

  return (
    <div className="sx-loginwrap" style={{ minHeight: '100vh', display: 'flex', background: '#fff' }}>
      <style>{`
        .sx-input { transition: border-color .15s, box-shadow .15s; }
        .sx-input:focus { border-color: #9C3BC4; box-shadow: 0 0 0 3px rgba(156,59,196,.15); }
        .sx-btn { transition: filter .15s, box-shadow .15s, transform .05s; }
        .sx-btn:hover:not(:disabled) { filter: brightness(1.06); box-shadow: 0 8px 22px rgba(124,58,237,.32); }
        .sx-btn:active:not(:disabled) { transform: translateY(1px); }
        .sx-mail { transition: background .15s, border-color .15s; }
        .sx-mail:hover { background: rgba(255,255,255,0.24); border-color: rgba(255,255,255,0.42); }
        @media (max-width: 860px) {
          .sx-visual { display: none !important; }
          .sx-formcol {
            flex: 1 1 100% !important;
            justify-content: flex-start !important;
            padding: calc(28px + env(safe-area-inset-top)) 16px calc(28px + env(safe-area-inset-bottom)) !important;
          }
          .sx-loginwrap { min-height: 100dvh !important; }
          .sx-logincard { max-width: min(420px, calc(100vw - 32px)) !important; margin: auto !important; }
          .sx-loginhead { margin-bottom: 32px !important; }
          .sx-loginfoot { margin-top: 28px !important; }
          .sx-input { min-height: 48px; }
          .sx-code { min-height: 56px; }
        }
      `}</style>

      <div className="sx-formcol" style={{
        flex: '0 0 46%', display: 'flex', flexDirection: 'column',
        justifyContent: 'center', padding: '48px 6%', minWidth: 0
      }}>
        <div className="sx-logincard" style={{ width: '100%', maxWidth: '380px', margin: '0 auto' }}>
          <div className="sx-loginhead" style={{ display: 'flex', alignItems: 'center', gap: '11px', marginBottom: '52px', flexWrap: 'wrap' }}>
            <img src="/seux-logo.png" alt="SEUX" style={{ height: '30px', width: 'auto', display: 'block' }} />
            <span style={{ fontSize: '22px', fontWeight: 600, color: colors.textPrimary, letterSpacing: '-0.01em' }}>Smart</span>
          </div>

          <h1 style={{ fontSize: '27px', fontWeight: 700, color: colors.textPrimary, margin: '0 0 6px', letterSpacing: '-0.02em' }}>{step === 'login' ? 'Oturum Aç' : 'E-posta Doğrulama'}</h1>
          <p className="sx-break" style={{ fontSize: '14px', color: colors.textSecondary, margin: '0 0 34px', maxWidth: '100%' }}>
            {step === 'login' ? 'Hesabınıza erişmek için giriş yapın.' : `${maskedEmail} adresine gönderilen 6 haneli kodu girin.`}
          </p>

          {step === 'login' ? (
          <form onSubmit={handleLogin}>
            <div style={{ marginBottom: '18px' }}>
              <label style={{ display: 'block', marginBottom: '7px', fontSize: '13px', fontWeight: 500, color: colors.textPrimary }}>E-posta</label>
              <input className="sx-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="ornek@seux.com.tr" autoFocus
                style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${colors.border}`, fontSize: '14px', color: colors.textPrimary, outline: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ marginBottom: '22px' }}>
              <label style={{ display: 'block', marginBottom: '7px', fontSize: '13px', fontWeight: 500, color: colors.textPrimary }}>Şifre</label>
              <input className="sx-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••"
                style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${colors.border}`, fontSize: '14px', color: colors.textPrimary, outline: 'none', boxSizing: 'border-box' }} />
            </div>

            {error && (
              <div style={{ background: colors.dangerLight, color: colors.dangerText, fontSize: '13px', padding: '10px 14px', borderRadius: '10px', marginBottom: '18px', border: `1px solid #FECACA` }}>{error}</div>
            )}

            <button className="sx-btn" type="submit" disabled={loading} style={{
              width: '100%', padding: '13px', background: WORD_GRADIENT,
              color: '#fff', border: 'none', borderRadius: '10px',
              cursor: loading ? 'default' : 'pointer', fontSize: '15px', fontWeight: 600,
              opacity: loading ? 0.7 : 1
            }}>{loading ? 'Giriş yapılıyor…' : 'Giriş Yap'}</button>
          </form>
          ) : (
          <form onSubmit={handleVerify}>
            <div style={{ marginBottom: '22px' }}>
              <label style={{ display: 'block', marginBottom: '7px', fontSize: '13px', fontWeight: 500, color: colors.textPrimary }}>Doğrulama Kodu</label>
              <input className="sx-input sx-code" type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6} value={code}
                onChange={e => setCode(e.target.value.replace(/\D/g, ''))} placeholder="••••••" autoFocus
                style={{ width: '100%', padding: '12px 14px', borderRadius: '10px', border: `1px solid ${colors.border}`, fontSize: '22px', letterSpacing: '10px', textAlign: 'center', color: colors.textPrimary, outline: 'none', boxSizing: 'border-box' }} />
            </div>

            {error && (
              <div style={{ background: colors.dangerLight, color: colors.dangerText, fontSize: '13px', padding: '10px 14px', borderRadius: '10px', marginBottom: '18px', border: `1px solid #FECACA` }}>{error}</div>
            )}
            {resent && (
              <div style={{ background: '#e6f4ea', color: '#137333', fontSize: '13px', padding: '10px 14px', borderRadius: '10px', marginBottom: '18px', border: '1px solid #ceead6' }}>Yeni kod gönderildi.</div>
            )}

            <button className="sx-btn" type="submit" disabled={loading || code.length < 6} style={{
              width: '100%', padding: '13px', background: WORD_GRADIENT,
              color: '#fff', border: 'none', borderRadius: '10px',
              cursor: loading ? 'default' : 'pointer', fontSize: '15px', fontWeight: 600,
              opacity: loading || code.length < 6 ? 0.7 : 1
            }}>{loading ? 'Doğrulanıyor…' : 'Doğrula ve Giriş Yap'}</button>

            <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginTop: '16px' }}>
              <button type="button" onClick={() => { setStep('login'); setError(''); setCode('') }}
                style={{ background: 'none', border: 'none', padding: 0, fontSize: '13px', color: colors.textSecondary, cursor: 'pointer' }}>← Geri</button>
              <button type="button" onClick={() => handleLogin()} disabled={loading}
                style={{ background: 'none', border: 'none', padding: 0, fontSize: '13px', color: '#9C3BC4', cursor: 'pointer', fontWeight: 500 }}>Kodu tekrar gönder</button>
            </div>
          </form>
          )}

          <p className="sx-loginfoot" style={{ marginTop: '48px', fontSize: '12px', color: colors.textMuted, textAlign: 'center' }}>© 2026 Seux Digital Agency</p>
        </div>
      </div>

      <div className="sx-visual" style={{
        flex: 1, position: 'relative', overflow: 'hidden',
        background: BRAND_GRADIENT,
        display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 8%'
      }}>
        <div style={{ position: 'absolute', top: '-130px', right: '-90px', width: '380px', height: '380px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.18), transparent 70%)' }} />
        <div style={{ position: 'absolute', bottom: '-160px', left: '-110px', width: '440px', height: '440px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(91,63,224,0.45), transparent 70%)' }} />

        <div style={{ position: 'relative', zIndex: 1, maxWidth: '460px' }}>
          <h2 style={{ fontSize: '46px', fontWeight: 800, lineHeight: 1.08, color: '#fff', margin: '0 0 20px', letterSpacing: '-0.03em' }}>Hoş Geldiniz</h2>
          <p style={{ fontSize: '18px', fontWeight: 500, lineHeight: 1.55, color: 'rgba(255,255,255,0.92)', margin: '0 0 34px' }}>
            Dönüşüm odaklı pazarlama modüllerini tek bir ekrandan yönetin
          </p>
          <a href="mailto:info@seux.com.tr" className="sx-mail" style={{
            display: 'inline-flex', alignItems: 'center', gap: '9px', fontSize: '14px', fontWeight: 500,
            color: '#fff', textDecoration: 'none', background: 'rgba(255,255,255,0.14)',
            border: '1px solid rgba(255,255,255,0.28)', padding: '11px 18px', borderRadius: '9999px'
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 7l9 6 9-6" /></svg>
            Sistem yöneticisine ulaşmak için tıklayın
          </a>
        </div>
      </div>
    </div>
  )
}

export default Login
